import { faCircleInfo, faDownload, faEllipsis, faFile, faFolderPlus, faPaperclip, faReply, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Checkbox, Col, Divider, Drawer, Form, Input, Modal, Radio, Row, Select, Upload } from "antd";
import Search from "antd/es/input/Search";
import { useState } from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';


const Messages = () => {
    const [value, setVlaue] = useState('Inbox');
    const [open, setOpen] = useState(false);

    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };


    return (<>
        <Row justify={"space-between"} align={"middle"} className="mb-4" gutter={[10, 10]}>
            <Col xl={12} lg={16} md={16} sm={20} xs={20}>
                <Radio.Group value={value} size="large" onChange={(e) => setVlaue(e.target.value)} >
                    <Radio.Button value="Inbox" className="pad-x rounded-2 fw-bold">Inbox</Radio.Button>
                    <Radio.Button value="Sent" className="pad-x rounded-2 fw-bold">Sent</Radio.Button>
                </Radio.Group>
            </Col>
            <Col xl={3} lg={4} md={6} sm={12} xs={20} className="text-end">
                <Button className="btn px-4 rounded-2 w-100" size="large" onClick={showDrawer}>New Message</Button>
            </Col>
        </Row>
        <Card bodyStyle={{ padding: "16px  0" }} style={{ minHeight: "78vh" }}>
            <Row justify={"space-between"} gutter={[10, 10]}>
                <Col xl={8} lg={6} md={16} sm={12} xs={20}>
                    <Form className="ps-2">
                        <Form.Item >
                            <Search size="large" placeholder="Search by Keyword" className="w-100" />
                        </Form.Item>
                    </Form>
                </Col>
                <Col xl={16} lg={16} md={18} sm={18} xs={22}>
                    <Row justify={"end"} gutter={[12, 10]} className="pe-2">
                        <Col xl={6} lg={8} md={12} sm={16} xs={20}>
                            <Form layout="horizontal">
                                <Form.Item>
                                    <Select defaultValue="Categories" size="large" >
                                        <Option>Categories</Option>
                                        <Option>Ask a Nurse</Option>
                                    </Select>
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={6} lg={8} md={12} sm={16} xs={20}>
                            <Form>
                                <Form.Item>
                                    <Select defaultValue="User" size="large">
                                        <Option>User</Option>
                                        <Option>Provider</Option>
                                        <Option>Nurse</Option>
                                    </Select>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Col xl={8} lg={10} md={14} sm={24} xs={24}>
                    <div className="border p-2">
                        <Row align={"top"}>
                            <Col span={2} className="">
                                <Checkbox className="pt-2" />
                            </Col>
                            <Col span={22}>
                                <div className="row">
                                    <span className="mb-0 col text-c">Jeff, Doctor - Emma Shelton</span>
                                    <span className="col-3 text-end ">3:15 PM</span>
                                </div>
                                <div className="row">
                                    <p className="mb-0 col">Checking-In</p>
                                    <FontAwesomeIcon icon={faReply} className="col-1 text-end " />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="border p-2">
                        <Row align={"top"}>
                            <Col span={2} className="">
                                <Checkbox className="pt-2" />
                            </Col>
                            <Col span={22}>
                                <div className="row">
                                    <span className="mb-0 col text-c">Layla, Doctor - Layla  London</span>
                                    <span className="col-3 text-end ">10/07/2023</span>
                                </div>
                                <div className="row">
                                    <p className="mb-0 col">Checking-In</p>
                                    <FontAwesomeIcon icon={faReply} className="col-1 text-end " />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="border p-2">
                        <Row align={"top"}>
                            <Col span={2} className="">
                                <Checkbox className="pt-2" />
                            </Col>
                            <Col span={22}>
                                <div className="row">
                                    <span className="mb-0 col text-c">Lil, Doctor - Raf Lil Back</span>
                                    <span className="col-3 text-end ">14/06/2023</span>
                                </div>
                                <div className="row">
                                    <p className="mb-0 col">Checking-In</p>
                                    <FontAwesomeIcon icon={faShare} className="col-1 text-end " />
                                </div>
                            </Col>
                        </Row>
                    </div><div className="border p-2">
                        <Row align={"top"}>
                            <Col span={2} className="">
                                <Checkbox className="pt-2" />
                            </Col>
                            <Col span={22}>
                                <div className="row">
                                    <span className="mb-0 col text-c">Eva, Doctor - Eva Elfie</span>
                                    <span className="col-3 text-end ">04/05/2023</span>
                                </div>
                                <div className="row">
                                    <p className="mb-0 col">Checking-In</p>
                                    <FontAwesomeIcon icon={faReply} className="col-1 text-end " />
                                </div>
                            </Col>
                        </Row>
                    </div><div className="border p-2">
                        <Row align={"top"}>
                            <Col span={2} className="">
                                <Checkbox className="pt-2" />
                            </Col>
                            <Col span={22}>
                                <div className="row">
                                    <span className="mb-0 col text-c">John, Doctor - Emma Watson</span>
                                    <span className="col-3 text-end ">01/02/2023</span>
                                </div>
                                <div className="row">
                                    <p className="mb-0 col">Checking-In</p>
                                    <FontAwesomeIcon icon={faShare} className="col-1 text-end " />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="border-end h-50">

                    </div>
                </Col>
                <Col xl={16} lg={14} md={10} sm={24} xs={24}>
                    <div className="border-top p-3" style={{ borderBottom: "none" }}>
                        <div className="row justify-content-sapce-between ps-2">
                            <div className="col">
                                <p className="text-c">Today 3:18 PM</p>
                            </div>
                            <div className="col text-end">
                                <FontAwesomeIcon icon={faReply} className="fs-5" />
                                &nbsp; &nbsp; <FontAwesomeIcon icon={faShare} className="fs-5" />
                                &nbsp; &nbsp; <FontAwesomeIcon icon={faEllipsis} className="fs-4" />
                            </div>
                        </div>
                        <h5 className="fw-bold ps-2">Checking-In</h5>
                        <div className="msg-address ps-2">
                            <div className="from">
                                <span className="from-label text-c">From</span>
                                <span className="from-address">Jeff Doctor</span>
                            </div>
                            <div className="from">
                                <span className="to-label text-c">To</span>
                                <span className="to-address">Ema Watson</span>
                            </div>
                        </div>
                        <Divider />
                        <div className="ps-2">
                            <FontAwesomeIcon icon={faFile} />&nbsp;&nbsp;<span>Appointment.pdf</span>&nbsp;&nbsp;<FontAwesomeIcon icon={faDownload} />
                            <Divider type="vertical" />
                            <FontAwesomeIcon icon={faFile} />&nbsp;&nbsp;<span>Appointment.pdf</span>&nbsp;&nbsp;<FontAwesomeIcon icon={faDownload} />
                            <Divider type="vertical" />
                        </div>
                        <Divider type="horizontal" />
                        <div className="from">
                            <span className="Question text-c ps-2">Question Type</span>
                            <span className="to-address ps-2">Ask a Nurse</span>
                        </div>
                        <Divider type="horizontal" />
                        <div>
                            <p className="ps-2">At what time we have to checking-in?</p>
                        </div>
                        <Divider type="horizontal" />

                    </div>
                </Col>
            </Row>

        </Card>

        <Drawer title="New Message" placement="right" onClose={onClose} open={open} >
            <div className="bg-grey mt-1 row align-items-center">
                <div className="col-1">
                    <FontAwesomeIcon icon={faCircleInfo} />
                </div>
                <div className="col-10">
                    <p className="fw-semibold mb-0">Message to providers directly is not supported. Please message general nurse mailbox.</p>
                </div>
            </div>
            <Form name="form_item_path" layout="vertical">
                <Form.Item label={<strong>From</strong>} name="From"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your From',
                        },
                    ]}
                >
                    <Select defaultValue="Emma Shelton" className="br-0" size="large">
                        <Option value="Emma Shelton">Emma Shelton</Option>
                    </Select>
                </Form.Item>
                <Form.Item label={<strong>Question Type</strong>} name="Question Type"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Question Type!',
                        },
                    ]}
                >
                    <Select defaultValue="Ask a Nurse" className="br-0" size="large">
                        <Option value="Ask a Nurse">Ask a Nurse</Option>
                    </Select>
                </Form.Item>
                <Form.Item label={<strong>Subject</strong>} name="Subject"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Subject',
                        },
                    ]}
                >
                    <Input className="rounded-0" size="large" />
                </Form.Item>
                <Form.Item
                    name="msg"
                    label={<strong>Message</strong>}
                    labelAlign="left"
                    rules={[
                        {
                            required: true,
                            message: "Please enter the message",
                        },
                    ]}
                >
                    <div className="richtextbox" aria-hidden="true" defaultValue="please enter a message">
                        <ReactQuill
                            theme="snow"
                            value={value}
                            // onChange=''
                            aria-hidden="false"
                            tabIndex="0"
                        />
                    </div>
                </Form.Item>

                <Row justify="space-between " align={"middle"}>
                    <Col span={8}>
                        <Upload className="text fs-6"> <FontAwesomeIcon icon={faPaperclip} />&nbsp; Attach files</Upload>
                    </Col>
                    <Col span={6}>
                        <Button type="primary" htmlType="submit" className="btn w-100" size="large">Search</Button>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    </>)
}

export default Messages;